import { useCallback } from 'react';
import { Tag } from 'antd';
import { PAYMENT_MODE_COLORS, PAYMENT_MODE_ICONS } from '../constants';

export const usePaymentTypeRender = () => {
  return useCallback((mode: string) => {
    if (!mode) return '-';

    const color =
      PAYMENT_MODE_COLORS[mode as keyof typeof PAYMENT_MODE_COLORS] ||
      'default';
    const icon =
      PAYMENT_MODE_ICONS[mode as keyof typeof PAYMENT_MODE_ICONS] || null;

    return (
      <Tag color={color} icon={icon} style={{ fontWeight: 500 }}>
        {mode}
      </Tag>
    );
  }, []);
};
